import Icon, { IconColor, IconType } from '@/components/view/atoms/icon/Icon'

interface Props {
  type: IconType
}

const IconMark = ({ type }: Props) => {
  return (
    <div className={'grid h-10 w-10 place-content-center rounded bg-fill-brand'}>
      <Icon type={type} color={IconColor.ON_COLOR} />
    </div>
  )
}

export default IconMark
